import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defaultProps } from '../../../node_module_clones/recompose';

const LOGO_RATIO = 1 / 2;
const LINE_THICKNESS_RATIO = 1 / 16;
const DEFAULT_SIZE = 62;

const enhance = defaultProps({
    size: DEFAULT_SIZE,
    fill: '#31303a',
    stroke: '#ffffff',
    animate: true,
});

const getLogoPath = ({ size, strokeWidth, logoSize }) => {
    const halfStrokeWidth = strokeWidth / 2;
    const offset = size / 2 - logoSize / 2;

    const x1 = 0 + offset + halfStrokeWidth;
    const y1 = 0 + offset + halfStrokeWidth;

    const x2 = 0 + offset + halfStrokeWidth;
    const y2 = logoSize + offset - halfStrokeWidth;

    const x3 = logoSize + offset - halfStrokeWidth;
    const y3 = logoSize + offset - halfStrokeWidth;

    const x4 = logoSize + offset - halfStrokeWidth;
    const y4 = 0 + offset + halfStrokeWidth;

    return `M ${x1} ${y1} L ${x2} ${y2} L ${x3} ${y3} L ${x4} ${y4} L ${x2} ${y2} M ${x1} ${y1} L ${x3} ${y3}`;
};

const getViewBox = (size) => `0 0 ${size} ${size}`;

const MilanoteLogo = (props) => {
    const {
        size,
        animate,
        stroke,
        fill,
        strokeWidth = size * LINE_THICKNESS_RATIO,
        logoSize = size * LOGO_RATIO,
    } = props;

    return (
        <div className="MilanoteLogo" style={{ position: 'relative', width: size, height: size }}>
            <svg
                viewBox={getViewBox(size)}
                width={size}
                height={size}
                style={{ position: 'absolute' }}
                className="path logo-spinner-circle"
            >
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={size / 2}
                    strokeWidth={strokeWidth}
                    strokeMiterlimit="10"
                    stroke="none"
                    fill={fill}
                />
            </svg>
            <svg
                viewBox={getViewBox(size)}
                width={size}
                height={size}
                style={{ position: 'absolute' }}
                className={classNames('logo-spinner-icon', { animate })}
            >
                <path
                    d={getLogoPath({ size, strokeWidth, logoSize })}
                    strokeWidth={strokeWidth}
                    stroke={stroke}
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

MilanoteLogo.propTypes = {
    size: PropTypes.number,
    stroke: PropTypes.string,
    fill: PropTypes.string,
    animate: PropTypes.bool,
    strokeWidth: PropTypes.number,
    logoSize: PropTypes.number,
};

export default enhance(MilanoteLogo);
